import { Alert, Card, Col, Row, Space } from "antd";
import React from "react";
import Footer from "../../../../../../components/common/Footer";
import FormAction from "../../../../../../components/common/FormAction";
import PageHeading from "../../../../../../components/common/PageHeading";
import RightBar from "../../../../../../components/common/RightBar";
import "./CarrierCompliance.css";
import CompanyInfoForm from "./ComplianceForms/CompanyInfoForm";
import ComplianceCard from "./ComplianceForms/ComplianceCard";
import RepresentativeContactForm from "./ComplianceForms/RepresentativeContactForm";
const CarrierComplianceSettings = () => {
  const GeneralSettingsRightBar = [];
  return (
    <>
      <PageHeading heading="Carrier Compliance Settings" />

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Space
            direction="vertical"
            style={{
              width: "100%",
            }}
          >
            <Alert
              message="Mobile phone carriers in the United States now require contact information for each party sending text messages. AppFolio is required to forward this information to phone carriers on your behalf.                  "
              description="We are not validating this information is accurate. If you provide false information here, phone carriers might not deliver your text message to their destination. P.O. Box addresses are not accepted by the mobile carriers for registration. For more information, please refer to our Help Center documentation."
              type="info"
              showIcon
              className="custom-alert-info"
            />
            <Alert
              description="This information has already been submitted to The Campaign Registry and can no longer be edited."
              type="warning"
              showIcon
              className="custom-alert-warning"
            />
          </Space>
        </Col>

        <Col span={24}>
          <Card title="Company Information" bordered={false}>
            <CompanyInfoForm />
          </Card>
        </Col>
        <Col span={24}>
          <Card title="Representative's Contact Information" bordered={false}>
            <RepresentativeContactForm />
          </Card>
        </Col>
        <Col span={24}>
          <Card title="Compliance" bordered={false}>
            <ComplianceCard />
          </Card>
        </Col>

        <Col>
          <FormAction />
        </Col>
      </Row>
      <Footer />

      <div className="RightSidebar">
        <RightBar RightBarData={GeneralSettingsRightBar} />
      </div>
    </>
  );
};

export default CarrierComplianceSettings;
